/**
 * Las conversaciones con Serena, el asistente de tusereno.es, tal como las
 * devuelve `/api/serena` (ver `server/src/services/serena.ts`).
 */

export type CanalSerena = 'burbuja' | 'alojamientos' | 'telefono';

export interface ConversacionSerenaResumen {
  id: string;
  canal: CanalSerena;
  pagina?: string;
  locale?: string;
  creada?: string;
  actualizada?: string;
  turnos: number;
  primerMensaje: string;
  herramientas: string[];
  clics: number;
  propietario: boolean;
}

export type TurnoSerena =
  | { tipo: 'visitante'; texto: string }
  | { tipo: 'serena'; texto: string }
  | { tipo: 'herramienta'; nombre: string; argumentos: string; resultado?: string };

export interface ConversacionSerenaDetalle extends Omit<ConversacionSerenaResumen, 'turnos'> {
  turnos: TurnoSerena[];
  clicsDetalle: { accion: string; id?: string; en: string }[];
  tokens?: { entrada?: number; salida?: number; cacheadas?: number };
}

export const CANAL_LABELS: Record<CanalSerena, string> = {
  burbuja: 'Burbuja',
  alojamientos: 'Alojamientos',
  telefono: 'Teléfono',
};

/** Qué hace cada herramienta, en palabras del equipo. */
export const HERRAMIENTA_LABELS: Record<string, string> = {
  buscar_casas: 'Buscó casas',
  buscar_flexible: 'Buscó fechas flexibles',
  ver_casa: 'Miró una casa',
  precio: 'Dio un precio',
  destinos: 'Listó destinos',
  proxima_temporada: 'Próxima temporada',
  gestionar_mi_casa: 'Propietario',
  trabajar_en_sereno: 'Empleo',
  tiempo: 'El tiempo',
  cerca_de: 'Cerca de…',
  fijar_busqueda: 'Rellenó la búsqueda',
};

export const CLIC_LABELS: Record<string, string> = {
  ver_casa: 'Abrió una casa',
  reservar: 'Pulsó reservar',
  proxima_temporada: 'Aviso de temporada',
  propietarios: 'Formulario de propietarios',
  empleo: 'Trabaja con nosotros',
};
